// extracted by mini-css-extract-plugin
module.exports = {"container":"evesReviews_container__k7vI0","title":"evesReviews_title__fk07Q","divider":"evesReviews_divider__3pcQz"};